__turbopack_context__.v({
  "container": "IconControls-module__EcJZNq__container",
  "control": "IconControls-module__EcJZNq__control",
  "icon": "IconControls-module__EcJZNq__icon",
  "iconControlsGlobal": "IconControls-module__EcJZNq__iconControlsGlobal",
  "popup": "IconControls-module__EcJZNq__popup",
});
